import { Color, Colors } from '~/assets/style/colors'
import { IconName } from '~/components/Icon'

export const SETTINGS_LABELS = ['profile', 'members', 'security', 'sites', 'refreshGroups', 'refreshExceptions', 'adQuality', 'abTest', 'apiKeys'] as const
type SettingsAccessLabels = typeof SETTINGS_LABELS
export type SettingsAccessLabel = SettingsAccessLabels[number]

/**
 * Where a card goes when its own name does not say it.
 *
 * `SettingsHomePage` otherwise derives the path from the label, which is what every card here wants —
 * `refreshGroups` → `refresh-groups`. Sites is the exception: the media list under Monetization replaced
 * it, so the card points out of Settings entirely and wears a "Moved" badge to say so.
 */
export const SETTINGS_NAV_PATH: Partial<Record<SettingsAccessLabel, string>> = {
  sites: '/monetization/inventory/medias',
}

export const SETTINGS_NAV_CONFIG: { [key in SettingsAccessLabel]: { title: string; content: string; color: Color; icon: IconName; badge?: string } } = {
  profile: {
    title: 'Profile',
    content: 'Manage your personal information and preferences.',
    color: Colors.Milka,
    icon: 'account_circle',
  },
  members: {
    title: 'Members',
    content: 'See your team members.',
    color: Colors.Violet,
    icon: 'group',
  },
  sites: {
    title: 'Sites',
    content: 'Now under Monetization, as Media & stacks — with every media’s product, status and Prebid variable.',
    color: Colors.Sun,
    icon: 'site',
    badge: 'Moved',
  },
  refreshGroups: {
    title: 'Refresh groups',
    content: 'Manage different rules on different segments.',
    color: Colors.Petrol,
    icon: 'folder',
  },
  refreshExceptions: {
    title: 'Refresh exceptions',
    content: 'Manage exceptions that will be applied to all refresh groups.',
    color: Colors.Forest,
    icon: 'settings',
  },
  abTest: {
    title: 'A/B tests',
    content: 'Monitor A/B tests running with Prebid and/or GAM',
    color: Colors.Pool,
    icon: 'population_split',
  },
  adQuality: {
    title: 'Server ad quality',
    content: 'Manage blocklists and other settings that will be applied to prebid server across all media.',
    color: Colors.Gold,
    icon: 'stars',
  },
  security: {
    title: 'Security',
    content: 'Manage authentification settings for the company',
    color: Colors.Lilac,
    icon: 'admin',
  },
  apiKeys: {
    title: 'API keys',
    content: 'Manage API keys for your account.',
    color: Colors.Salmon,
    icon: 'key',
  },
} as const
